import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { style: {"height":"40px","line-height":"40px","float":"left","margin-top":"-15px"} }
const _hoisted_2 = { style: {"float":"right","height":"40px","line-height":"40px","margin-top":"-10px","margin-right":"-10px"} }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { class: "link" }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { style: {"clear":"both","height":"30px"} }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CloseBold = _resolveComponent("CloseBold")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_miezz_select = _resolveComponent("miezz-select")!
  const _component_el_autocomplete = _resolveComponent("el-autocomplete")!
  const _component_miezz_input = _resolveComponent("miezz-input")!
  const _component_miezz_form = _resolveComponent("miezz-form")!
  const _component_miezz_button_bar = _resolveComponent("miezz-button-bar")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    modelValue: _ctx.ruleForm.Visible,
    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.ruleForm.Visible) = $event)),
    "show-close": false,
    style: {"width":"50%"},
    "close-on-click-modal": false,
    "close-on-press-escape": false,
    "append-to-body": true
  }, {
    header: _withCtx(({ close }) => [
      _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.ruleForm.Title), 1),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_el_icon, {
          style: {"cursor":"pointer"},
          onClick: close
        }, {
          default: _withCtx(() => [
            _createVNode(_component_CloseBold)
          ]),
          _: 2
        }, 1032, ["onClick"])
      ])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_miezz_form, {
        modelValue: _ctx.formSupplier,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.formSupplier) = $event)),
        ref: "ref-form-supplier",
        "label-width": "120px"
      }, {
        "form-item": _withCtx(({ item }) => [
          (item.Prop == 'SupplierSource')
            ? (_openBlock(), _createBlock(_component_el_form_item, {
                key: 0,
                label: item.Label,
                prop: item.Prop
              }, {
                default: _withCtx(() => [
                  (_ctx.isDetail != true)
                    ? (_openBlock(), _createBlock(_component_el_select, {
                        key: 0,
                        modelValue: _ctx.formSupplier.Data.SupplierSource,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formSupplier.Data.SupplierSource) = $event)),
                        placeholder: "请选择",
                        onChange: _ctx.onSupplierSourceChanged
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.EnumSupplierSourceOptionNew, (item) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: item.Value,
                              label: item.Label,
                              value: item.Value
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 2
                      }, 1032, ["modelValue", "onChange"]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_ctx.formatEnum(
                                    _ctx.EnumSupplierSourceOptionNew,
                                    _ctx.formSupplier.Data.SupplierSource
                                  )), 1))
                ]),
                _: 2
              }, 1032, ["label", "prop"]))
            : _createCommentVNode("", true),
          (item.Prop == 'SupplierCompanyTypeId')
            ? (_openBlock(), _createBlock(_component_el_form_item, {
                key: 1,
                label: item.Label,
                prop: item.Prop
              }, {
                default: _withCtx(() => [
                  (_ctx.isDetail!=true)
                    ? (_openBlock(), _createBlock(_component_miezz_select, {
                        key: _ctx.supplierRandom,
                        onHandleChange: _ctx.onSupplierTypeIdChanged,
                        modelValue: _ctx.formSupplier.Data.SupplierCompanyTypeId,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formSupplier.Data.SupplierCompanyTypeId) = $event)),
                        label: _ctx.formSupplier.Data.SupplierCompanyTypeLabel,
                        "onUpdate:label": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formSupplier.Data.SupplierCompanyTypeLabel) = $event)),
                        options: _ctx.supplierTypes
                      }, null, 8, ["onHandleChange", "modelValue", "label", "options"]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_ctx.formSupplier.Data.SupplierCompanyTypeLabel ?? "暂无数据"), 1))
                ]),
                _: 2
              }, 1032, ["label", "prop"]))
            : _createCommentVNode("", true),
          (item.Prop == 'SupplierCompanyId')
            ? (_openBlock(), _createBlock(_component_el_form_item, {
                key: 2,
                label: item.Label,
                prop: item.Prop
              }, {
                default: _withCtx(() => [
                  (_ctx.isDetail != true)
                    ? (_openBlock(), _createBlock(_component_el_autocomplete, {
                        key: 0,
                        modelValue: _ctx.formSupplier.Data.SupplierCompanyLabel,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formSupplier.Data.SupplierCompanyLabel) = $event)),
                        clearable: true,
                        style: {"width":"100% !important"},
                        "fetch-suggestions": _ctx.querySearchSupplier,
                        "popper-class": "my-autocomplete",
                        placeholder: "请选择",
                        onSelect: _ctx.handleSelectSupplier,
                        onChange: _ctx.onSupplierCompanyIdChanged,
                        onClear: _ctx.onClearSupplier,
                        onBlur: _ctx.onChangeSupplier
                      }, {
                        default: _withCtx(({ item }) => [
                          _createElementVNode("span", _hoisted_5, _toDisplayString(item.NameZh), 1)
                        ]),
                        _: 2
                      }, 1032, ["modelValue", "fetch-suggestions", "onSelect", "onChange", "onClear", "onBlur"]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(_ctx.formSupplier.Data.SupplierCompanyLabel ?? "暂无数据"), 1))
                ]),
                _: 2
              }, 1032, ["label", "prop"]))
            : _createCommentVNode("", true),
          (item.Prop == 'SupplierCompanyContactLabel')
            ? (_openBlock(), _createBlock(_component_el_form_item, {
                key: 3,
                label: item.Label
              }, {
                default: _withCtx(() => [
                  (_ctx.isDetail!=true)
                    ? (_openBlock(), _createBlock(_component_miezz_input, {
                        key: 0,
                        clearable: true,
                        modelValue: _ctx.formSupplier.Data.SupplierCompanyContactLabel,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formSupplier.Data.SupplierCompanyContactLabel) = $event)),
                        "fetch-suggestions": _ctx.getSupplierCompanyContact,
                        "trigger-on-focus": true,
                        "value-key": "Label",
                        onHandleSelect: _ctx.onChangeSupplierCompanyContactLabel,
                        disabled: !_ctx.formSupplier.Data.SupplierCompanyId
                      }, null, 8, ["modelValue", "fetch-suggestions", "onHandleSelect", "disabled"]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_ctx.formSupplier.Data.SupplierCompanyContactLabel ?? "暂无数据"), 1))
                ]),
                _: 2
              }, 1032, ["label"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _hoisted_8,
      _createVNode(_component_miezz_button_bar, {
        modelValue: _ctx.bottomButtons,
        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.bottomButtons) = $event)),
        isBackground: true,
        onHandleClick: _ctx.handleClick
      }, null, 8, ["modelValue", "onHandleClick"])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}